
export default {
  props: {
    wareInfo: {
      type: Object,
      default: () => {}
    },
    shopLogo: {
      type: String,
      default: ""
    },
    venderId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShow: true,
      totalCount: 0
    }
  },
  computed: {
    isNotWellcome() {
      return this.venderId != 5
    }
  },
  watch: {
    wareInfo: {
      handler(newVal) {
        if (newVal && newVal.itemList) {
          newVal.itemList.forEach(item => {
            this.totalCount += Number(item.wareCount)
          })
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    goDetails(item) {
      if (this.venderId != 5) return
      const skuId = item.sku
      this.$navigation.push({
        path: `${this.MAIN_PATH}/p/${encodeURIComponent(item.wareName)}/i/${skuId}.html`
      })
    }
  }
}
